import type { CoresAplicativoModel } from "../models/coresAplicativoModel"

export enum CoresAplicativoActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
    RESETAR = "RESETAR",
}

export type CoresAplicativoActionModel =
    | {
          type: CoresAplicativoActionsTypes.CARREGAR
          payload: CoresAplicativoModel
      }
    | {
          type: CoresAplicativoActionsTypes.ATUALIZAR_CAMPO
          payload: { campo: keyof CoresAplicativoModel; valor: string }
      }
    | {
          type: CoresAplicativoActionsTypes.RESETAR
      }
